import React from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css';   // theme
import 'primeicons/primeicons.css';
import ReactGA from "react-ga4";
import { NotFound } from 'views/error/404';
import LogRocket from 'logrocket';
import { SocketProvider } from './socketContext';

// components
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { PrivateRoute, AuthProvider } from './auth';
import { History, View } from 'components/lib';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// Configure axios defaults for JWT cookie handling
axios.defaults.withCredentials = true;

// Initialize LogRocket only in production environment
if (process.env.NODE_ENV === 'production') {
  LogRocket.init(process.env.REACT_APP_LOGROCKET_ID);
}

ReactGA.initialize("G-G6W9YJHVDJ");

// settings
const Settings = require('settings.json');
const StripePromise = loadStripe(Settings[process.env.NODE_ENV].stripe.publishableAPIKey);

const Routes = [

  ...require('routes/account').default,
  ...require('routes/profile').default,
  ...require('routes/app').default,
  ...require('routes/auth').default,
  ...require('routes/firm').default,
  
]

function AppWithSocket() {
  const token = Cookies.get('jwt');

  // render the routes
  return(
    <SocketProvider jwt={token}>
      <Elements stripe={ StripePromise }>
        <PrimeReactProvider>
          <AuthProvider>
            <Router history={ History }>
              <Switch>
                <Route exact path="/" render={() => <Redirect to="/signin" />} />
                { Routes.map(route => {

                  const RouteType = route.permission ? PrivateRoute : Route;

                  return (
                    <RouteType key={ route.path } exact path={ route.path }
                      permission={ route.permission } accountType={ route.accountType } render={(data) => {
                        // Get user from localStorage for dynamic titles
                        const user = JSON.parse(localStorage.getItem('user') || '{}');
                        const title = typeof route.title === 'function' ? route.title(user) : route.title;
                        
                        return (
                          <View display={ route.view } layout={ route.layout }
                            title={ title } data={ data }
                          />
                        );
                      }}
                    />
                  );
                })}

                { /* 404 */}
                <Route render={() => <View display={ NotFound }
                  layout='home' title='404 Not Found' />}/>

              </Switch>
            </Router>
          </AuthProvider>
        </PrimeReactProvider>
      </Elements>
    </SocketProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppWithSocket />
    </AuthProvider>
  );
}
